module.exports = __webpack_public_path__ + "static/media/instagram-grey.97387a41.svg";